import { api } from "./index.ts";

export interface Review {
    id: string;
    name: string;
    rating: number;
    content: string;
    status: string;
    avatar?: string | null;
    images: string[];
    videos: string[];
    project_id: string;
    created_at: string;
    updated_at: string;
}

export async function getReviews(): Promise<Review[]> {
    try {
        const response = await api.get("/reviews");
        return response.data.reviews || response.data || [];
    } catch (err) {
        return [];
    }
}

export async function getReview(id: string): Promise<Review | null> {
    try {
        const response = await api.get(`/reviews/${id}`);
        return response.data.review || response.data || null;
    } catch (err) {
        return null;
    }
}

export async function addReview(payload: {
    name: string;
    rating: number;
    content: string;
    status: string;
    avatar?: string | null;
    images?: string[];
    videos?: string[];
    project_id: string | null;
}) {
    try {
        const requestData: any = {
            name: payload.name,
            rating: payload.rating,
            content: payload.content,
            status: 'accepted',
            project_id: payload.project_id,
            avatar: payload.avatar || null,
            images: Array.isArray(payload.images) ? payload.images : [],
            videos: Array.isArray(payload.videos) ? payload.videos : [],
        };

        const response = await api.post("/reviews", { review: requestData });
        return response.data.review || response.data;
    } catch (err: any) {
        if (err.response) console.error("Детали ошибки:", err.response.data);
        throw err;
    }
}

export async function updateReview(id: string, payload: {
    name?: string;
    rating?: number;
    content?: string;
    status: string;
    avatar?: string | null;
    images?: string[];
    videos?: string[];
    project_id?: string | null;
}) {
    try {
        const requestData: any = {};

        if (payload.name !== undefined) requestData.name = payload.name;
        if (payload.status !== undefined) requestData.status = payload.status;
        if (payload.rating !== undefined) requestData.rating = payload.rating;
        if (payload.content !== undefined) requestData.content = payload.content;
        if (payload.avatar !== undefined) requestData.avatar = payload.avatar;
        if (payload.images !== undefined) requestData.images = Array.isArray(payload.images) ? payload.images : [];
        if (payload.videos !== undefined) requestData.videos = Array.isArray(payload.videos) ? payload.videos : [];
        if (payload.project_id !== undefined) requestData.project_id = payload.project_id;

        const putResp = await api.put(`/reviews/${id}`, { review: requestData });
        console.log("Sending update payload:", { review: requestData });
        console.log("PUT response:", putResp.data);

        if (putResp.data && (putResp.data.review || putResp.data.id)) {
            return putResp.data.review || putResp.data;
        }

        const fresh = await getReview(id);
        if (fresh) return fresh;

        const all = await getReviews();
        const found = (all || []).find((r: any) => r && r.id === id);
        if (found) return found;

        return putResp.data;
    } catch (err: any) {
        if (err.response) console.error("Детали ошибки:", err.response.data);
        throw err;
    }
}

export async function deleteReview(id: string) {
    try {
        await api.delete(`/reviews/${id}`);
        return true;
    } catch (err) {
        throw err;
    }
}